import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class UniversityMarketingTagService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.ALL_MARKETING_TAG_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id));
    }

    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id), data);
    }

    update( id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id), data);
    }

    delete(id): Observable<any> {
        return this.deleteRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id));
    }


    /*updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_MARKETING_TAG_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_MARKETING_TAG_STATUS(id), data);
    }

    getByLanding(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_MARKETING_TAG(id), data);
    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_MARKETING_TAG_BY_ADMIN(id), data);
    }

    getByAdmin(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_MARKETING_TAG_BY_ADMIN(id), data);
    }

    updateByAdmin(universityId, id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITY_MARKETING_TAG_UPDATE_BY_ADMIN(universityId, id), data);
    }*/
}
